import { AuxSelectorFilter, VariableType } from '@/models/etc/types';

/**
 * Context passed from AuxSelector to strategy functions.
 * Carries component props / state that strategies may need, without coupling to `this`.
 */
export interface StrategyContext {
  setId: number;
  excludeId: number;
  preferredSegment: number;
  componentModel: any;
  allowFreeInput: boolean;
  searchCache: any[];
  t: (key: string) => string;
  emit: (event: string, payload?: any) => void;
  // Id вхождения и признак параметр/поле - нужны стратегии загрузки набора значений
  instanceId?: number;
  isParameterInstance?: boolean;
}

export interface SelectorStrategy {
  /** Extract display entity from model element. Default: identity */
  fromFilter?: (entity: any) => any;
  /** Wrap display entity back into model format. Default: identity */
  toFilter?: (entity: any, originalFilter?: any) => any;
  /** Load data from server */
  loadMore: (
    filter: string | AuxSelectorFilter,
    count: number,
    offset: number,
    ctx: StrategyContext,
  ) => Promise<any[]>;
  /** Optional: reset internal cache when selector is closed */
  resetCache?: () => void;
  /** Optional: delete list item on server. Presence enables the delete control in the list */
  deleteItem?: (item: any, ctx: StrategyContext) => Promise<boolean>;
  /** Optional: rights gate for the delete control. Checked at render time */
  canDeleteItems?: () => boolean;
  /** Optional: reactive marker of a just created item. Its change means the item is already
      on the server, so the list can be reloaded */
  createdSignal?: () => any;

  elementType: VariableType;
  closeAfterSelect: boolean;
  hideCheckboxes: boolean;
  hasDeps: boolean;
  isObjectFilter: boolean;
  /** Override for allowMultiple prop (undefined = use prop as-is) */
  allowMultipleOverride?: boolean;
  /** All data loads in a single request (no offset-based pagination) */
  singleLoad?: boolean;
  /** i18n key for the subheader label */
  label: string;
}

const identity = <T>(x: T): T => x;

export function resolveFromFilter(s: SelectorStrategy): (entity: any) => any {
  return s.fromFilter ?? identity;
}

export function resolveToFilter(s: SelectorStrategy): (entity: any, orig?: any) => any {
  return s.toFilter ?? identity;
}
